import { JwtClaims } from '../models/jwtClaims.model';

export function decodeJwtClaims(token: string | null): JwtClaims | null {
    const payload = token?.split('.')[1];
    if (!payload) {
        return null;
    }

    try {
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const claims: unknown = JSON.parse(window.atob(padded));
        return typeof claims === 'object' && claims !== null ? claims as JwtClaims : null;
    } catch {
        return null;
    }
}
